import { render, staticRenderFns } from "./LeftLowerBarLiteDesign.vue?vue&type=template&id=bd5a16fc&scoped=true&"
import script from "./LeftLowerBarLiteDesign.vue?vue&type=script&lang=js&"
export * from "./LeftLowerBarLiteDesign.vue?vue&type=script&lang=js&"
import style0 from "./LeftLowerBarLiteDesign.vue?vue&type=style&index=0&id=bd5a16fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd5a16fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd5a16fc')) {
      api.createRecord('bd5a16fc', component.options)
    } else {
      api.reload('bd5a16fc', component.options)
    }
    module.hot.accept("./LeftLowerBarLiteDesign.vue?vue&type=template&id=bd5a16fc&scoped=true&", function () {
      api.rerender('bd5a16fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/LowerBar/LowerBarLeftSide/Lite/LeftLowerBarLiteDesign.vue"
export default component.exports